import { AxiosError, AxiosHeaders, isAxiosError } from "axios";

/**
 * Given a value that was thrown (in javascript all sorts of values can be
 * thrown, not only Error-s), tries to extract as much information from it as
 * possible.
 */
export function extractThrownValueDetails(thrownValue: any) {
  try {
    // Primitive value
    if (
      typeof thrownValue === "string" ||
      typeof thrownValue === "number" ||
      typeof thrownValue === "boolean" ||
      thrownValue === null ||
      typeof thrownValue === "undefined" ||
      typeof thrownValue === "symbol" ||
      typeof thrownValue === "bigint"
    ) {
      return {
        message: "primitive value thrown",
        thrownValueType: typeof thrownValue,
        stringifiedThrownValue: String(thrownValue),
      };
    }

    // Function value
    if (typeof thrownValue === "function") {
      return {
        message: "function value thrown",
        thrownFunctionName: thrownValue.name,
      };
    }

    // Object value
    return {
      message: thrownValue.message,
      name: thrownValue.name,
      stack: thrownValue.stack,
      code: thrownValue.code,
      signal: thrownValue.signal,
      ...(isAxiosError(thrownValue)
        ? extractAxiosErrorDetails(thrownValue)
        : null),
    };
  } catch {
    return {
      message:
        "A value was thrown for which it was not possible to extract any detail",
    };
  }
}

function extractAxiosErrorDetails(error: AxiosError) {
  return {
    axiosConfig: error.config
      ? {
          method: error.config.method,
          baseURL: error.config.baseURL,
          url: error.config.url,
          params: error.config.params,
          headers: redactRequestHeaders(
            AxiosHeaders.prototype.toJSON.call(error.config.headers),
          ),
          data: error.config.data,
        }
      : undefined,
    axiosResponse: error.response
      ? {
          status: error.response.status,
          headers: AxiosHeaders.prototype.toJSON.call(
            error.response.headers,
          ) as object,
          data: error.response.data,
        }
      : undefined,
  };
}

function redactRequestHeaders(headers: Record<string, any>) {
  const headersToRedact = new Set(["authorization"]);
  Object.keys(headers).forEach((header) => {
    if (headersToRedact.has(header.toLowerCase())) {
      headers[header] = "REDACTED";
    }
  });
  return headers;
}
